// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "app-" + chunkId + "." + {"679":"2055f5499c044b8fc2d9","936":"05531222c1bd47a07a0d"}[chunkId] + ".js";
};